import { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { rgApi, EXTRA_ICONS, fmtShortDate, firstName } from "@/lib/rgApi";

/**
 * GuestsList — liste plate des voyageurs, avec recherche et filtre statut.
 */

export default function GuestsList() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [futureOnly, setFutureOnly] = useState(true);
  const nav = useNavigate();

  const load = useCallback(async () => {
    try {
      const list = await rgApi.listReservations(futureOnly);
      setItems(list);
    } catch (e) {
      if (e.status === 401) nav("/admin");
    }
  }, [futureOnly, nav]);

  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(() => {
    const term = q.toLowerCase().trim();
    if (!term) return items;
    return items.filter((r) =>
      (r.name || "").toLowerCase().includes(term) ||
      (r.phone || "").includes(term) ||
      (r.lodgify_id || "").toLowerCase().includes(term)
    );
  }, [items, q]);

  return (
    <div className="rg-page" data-testid="rg-guests-page">
      <h2 className="rg-h2">Voyageurs</h2>
      <div className="rg-row" style={{ gap: 10, margin: "12px 0 16px", flexWrap: "wrap" }}>
        <div style={{ position: "relative", flex: 1, minWidth: 260 }}>
          <Search size={14} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "var(--rg-text-3)" }} />
          <input
            data-testid="rg-guests-search"
            className="rg-input"
            style={{ paddingLeft: 30 }}
            placeholder="Rechercher un nom, téléphone, ID Lodgify…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <label className="rg-row" style={{ gap: 6, fontSize: 13, color: "var(--rg-text-2)" }}>
          <input type="checkbox" checked={futureOnly} onChange={(e) => setFutureOnly(e.target.checked)} data-testid="rg-guests-future" />
          Uniquement à venir
        </label>
      </div>

      {filtered.length === 0 ? (
        <div className="rg-card rg-muted" style={{ textAlign: "center" }}>Aucun voyageur trouvé.</div>
      ) : (
        filtered.map((r) => {
          const icons = (r.extras || []).map((e) => EXTRA_ICONS[e]).join(" ");
          return (
            <div key={r.id} className="rg-resa" onClick={() => nav(`/admin/gestion/voyageur/${r.id}`)} data-testid={`rg-guests-item-${r.id}`}>
              <div className="rg-row" style={{ justifyContent: "space-between" }}>
                <div>
                  <div className="rg-resa-name">{r.name}</div>
                  <div className="rg-resa-dates">{fmtShortDate(r.date_arrival)} → {fmtShortDate(r.date_departure)}</div>
                </div>
                <div style={{ fontSize: 16 }}>{icons}</div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
